import { render, staticRenderFns } from "./ItemQueryContent.vue?vue&type=template&id=e10b651a&scoped=true"
import script from "./ItemQueryContent.vue?vue&type=script&lang=js"
export * from "./ItemQueryContent.vue?vue&type=script&lang=js"
import style0 from "./ItemQueryContent.vue?vue&type=style&index=0&id=e10b651a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10b651a",
  null
  
)

export default component.exports